import React, {useState, useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso, AddItemToList, ArticleListAssociationForm } from "@gull";
import { IsAuthContext } from 'app/App';

const MassAssociateSupplementList = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [showAccordion,setShowAccordion]=useState(false)
    const [mode,setMode]=useState('filter')

    const moduleErp = authParam.modules.find(value=>value.name=='erp')
    const articleListModuleActive = moduleErp.params.hasOwnProperty('article_list') && moduleErp.params.article_list.active

    return (
        <CardPerso header={<>
                <button
                    className="btn btn-sm btn-success"
                    onClick={()=>setShowAccordion(!showAccordion)}
                >
                    {t('massAssociateSupplementList')}
                </button>
            </>}>

            {(showAccordion) &&
                <>
                    <div className="form-group mb-3">
                        <select className="form-control w-auto" value={mode} onChange={(e)=>setMode(e.target.value)}>
                            <option value="filter">{t('filterArticlesMode')}</option>
                            {articleListModuleActive && <option value="articleList">{t('existingArticleListMode')}</option>}
                        </select>
                    </div>

                    {(mode=='articleList' && articleListModuleActive) &&
                        <ArticleListAssociationForm
                            url={"api/erp/supplement_list/mass_associate/"+props.supplementListId}
                            onSuccess={()=>props.setReload(Date.now())}
                        />
                    }

                    {(mode=='filter') &&
                        <AddItemToList
                            liaisons={props.liaisons}
                            customFields={props.customFields}
                            setToast={props.setToast}
                            customInterface={props.customInterface}
                            setCustomInterface={props.setCustomInterface}
                            setReload={props.setReload}
                            setShowAccordion={setShowAccordion}
                            tableName={"baseMassAssociateSupplementList"}
                            urlAddItems={"api/erp/supplement_list/mass_associate/"}
                            from='supplementListMassAssociate'
                        />
                    }
                </>
            }
        </CardPerso>
    );
}

export default MassAssociateSupplementList;
